<script>
export default {}
</script>

<template>
  <v-tooltip v-bind="$attrs">
    <template v-slot:activator="{ on }">
      <div v-on="on">
        <slot>
          <v-icon>mdi-information</v-icon>
        </slot>
      </div>
    </template>
    <slot name="content">Coming Soon!</slot>
  </v-tooltip>
</template>

<style lang="scss" module>
@import '@design';
</style>
